import React from 'react'
import Toprated from './Toprated'


const Freetrial = () => {
  return (
    <>
        <Toprated/>
    </>
  )
}

export default Freetrial